import $ from "jquery";

export default function onWindowLoad() {
    $('head').find('link[rel="icon"]').attr('type', 'image/png');
    if(window.innerWidth > 991) {
        $(".edv-nav-mobile").attr("aria-hidden","true");
        $(".edv-nav-desktop").attr("aria-hidden","false");
        $(".edv-services-template-nav-mobile").attr("aria-hidden","true").addClass('d-none');
        $(".edv-services-template-nav-desktop").attr("aria-hidden","false").removeClass('d-none');
    }
    if(window.innerWidth <= 991) {
        $(".edv-services-template-nav-mobile").attr("aria-hidden","false").removeClass('d-none');
        $(".edv-services-template-nav-desktop").attr("aria-hidden","true").addClass('d-none');
        $(".edv-nav-mobile").attr("aria-hidden","false");
        $(".edv-nav-desktop").attr("aria-hidden","true");
    }

    if($('.level-2-items-desc .nav-item-desc.current-sub-menu-item').length > 0 ) {
        $('.level-2-items-desc .nav-item-desc.current-sub-menu-item').css('z-index','1').css('opacity','1');
    } else {
        $('.level-2-items-desc .nav-item-desc:first-child').css('z-index','1').css('opacity','1');
    }

}